export default __webpack_public_path__ + "static/media/CV_VICTOR_IGUALADA.48c38577.pdf";